// extracted by mini-css-extract-plugin
export default {"section":"ContactForm_section__Yogoh","modal":"ContactForm_modal__ugqY9"};